import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { PDPVersion, ProductImageSizesPortraitEnum, } from '@as-react/common-types';
import { isOneSizeProduct } from '@as-react/common-utils';
import { useIsClient, useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import StickyBar from '../components/product-detail/sticky-bar/StickyBar';
import { useIsInViewport } from '../hooks/useIsInViewport';
import { usePriceProps } from '../hooks/usePriceProps';
import { basketActions } from '../redux/basket/actions/BasketActions.creators';
import { makeGetBasketValidationState } from '../redux/basket/selectors/BasketSelector';
import { productActions } from '../redux/product/actions/ProductActions';
import { makeGetDetailInformation, makeGetDynamicSavingsInformation, makeGetIsSelectedSizeSoldOut, makeGetPreviewInformation, makeGetPriceInformation, makeGetProductDefaults, makeGetProductFulfillment, makeGetProductFulfillmentBySize, makeGetProductSizes, makeGetProductState, makeGetSelectedColorId, makeGetSelectedSku, makeGetSizeRecommendation, } from '../redux/product/selectors/ProductSelector';
import { wishListActions } from '../redux/wishList/actions/WishListActions.creators';
import { makeGetProductColorIsInWishList } from '../redux/wishList/selectors/WishListSelectors';
import { getImageSourceSetByProductCode } from '../util/ImageUtil';
import { useProductDetailContext } from './product/ProductDetailV2Container';
export const StickyBarContainer = ({ isHidden, setHidden }) => {
    var _a, _b, _c;
    const dispatch = useDispatch();
    const { selectedAdditionalProducts } = useProductDetailContext();
    const { ctaRef } = useProductDetailContext();
    const { isInViewport, refPosition } = useIsInViewport(ctaRef, { threshold: 0.75 });
    useEffect(() => {
        setHidden(!refPosition || refPosition === 'below' || isInViewport);
    }, [isInViewport, refPosition]);
    const handleAddToBasket = (quantity, location) => dispatch(selectedAdditionalProducts.length > 0
        ? basketActions.createAddAdditionalProductsAction(selectedAdditionalProducts, quantity, location)
        : basketActions.createAddAction(quantity, location, PDPVersion.V2));
    const handleToggleWishList = (product) => dispatch(wishListActions.toggleProduct(product));
    const handleOpenCC = () => dispatch(basketActions.createCCPopupOpenAction());
    const handleSizeForgotten = (location) => dispatch(basketActions.createSizeForgottenShowAction(location));
    const handleSelectSize = ({ sku }) => dispatch(productActions.createSelectSizeAction({ sku }));
    const handleSetBasketError = (error) => dispatch(basketActions.createErrorAction(error));
    const { oneSizeProductCode, isShopLanding, checkoutCc: clickAndCollectEnabled, productImageConfig } = useAemConfig();
    const selectedSku = useSelector(makeGetSelectedSku());
    const productColorIsInWishList = useSelector(makeGetProductColorIsInWishList());
    const selectedColorId = useSelector(makeGetSelectedColorId());
    const { productCode, productId } = useSelector(makeGetProductDefaults());
    const { selectedColorOutOfstock } = useSelector(makeGetProductState());
    const sizes = useSelector(makeGetProductSizes());
    const basketValidationState = useSelector(makeGetBasketValidationState());
    const sizeRecommendationData = useSelector(makeGetSizeRecommendation());
    const priceInformation = useSelector(makeGetPriceInformation());
    const dynamicSavingsInformation = useSelector(makeGetDynamicSavingsInformation());
    const previewInformation = useSelector(makeGetPreviewInformation());
    const detailInformation = useSelector(makeGetDetailInformation());
    const { ccExcluded, hdExcluded } = useSelector(makeGetProductFulfillment());
    const fulfillmentBySize = useSelector(makeGetProductFulfillmentBySize());
    const isSelectedSizeSoldOut = useSelector(makeGetIsSelectedSizeSoldOut());
    const isMobile = useMediaQueryMatchesOnMobile();
    const isClient = useIsClient();
    const oneSizeProduct = isOneSizeProduct(sizes, oneSizeProductCode);
    const imageUrl = ((_a = previewInformation.images[0]) === null || _a === void 0 ? void 0 : _a.picture)
        ? getImageSourceSetByProductCode(productCode, (_b = previewInformation.images[0]) === null || _b === void 0 ? void 0 : _b.picture, productImageConfig)
        : undefined;
    const wishListProduct = {
        colorId: selectedColorId,
        productCode: productCode,
        productId: Number(productId),
        sku: selectedSku,
    };
    const productPriceProps = usePriceProps({
        priceInformation,
        dynamicSavingsInformation,
        enablePriceReference: true,
    });
    if ((ccExcluded && hdExcluded) || !isClient || selectedColorOutOfstock) {
        return null;
    }
    return (_jsx(StickyBar, { isHidden: isHidden, isMobile: isMobile, selectedSku: selectedSku, productColorIsInWishList: productColorIsInWishList, wishListProduct: wishListProduct, isOneSizeProduct: oneSizeProduct, sizes: sizes, basketValidationState: basketValidationState, sizeRecommendation: sizeRecommendationData.colorBased, shopLandingEnabledFlag: isShopLanding, clickAndCollectEnabled: clickAndCollectEnabled, hdExcluded: hdExcluded, addToBasket: handleAddToBasket, openCC: handleOpenCC, sizeForgotten: handleSizeForgotten, toggleWishList: handleToggleWishList, selectSize: handleSelectSize, setBasketError: handleSetBasketError, productPriceProps: productPriceProps, imageUrl: (_c = imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl[ProductImageSizesPortraitEnum.thumb]) !== null && _c !== void 0 ? _c : '', detailInformation: detailInformation, storeSourceExcluded: fulfillmentBySize === null || fulfillmentBySize === void 0 ? void 0 : fulfillmentBySize.storeSourceExcluded, isSelectedSizeSoldOut: isSelectedSizeSoldOut }));
};
